import * as React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { EventsGroupViewCompetition } from 'src/domains/sportsbook/state/eventsListState/eventsGroup/EventsGroupView';
import { UnifiedSportEventsListState } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedSportEventsListState';
import { SectionHeaderSeeMore } from 'src/ui/components/collapse/sports/05/SectionHeaderSeeMore';
import { observer } from 'src/utils/mobx-react';

interface OutrightsCompetitionsListPropsType extends React.PropsWithChildren {
    competition: EventsGroupViewCompetition;
    sportId: string;
    eventsListState: UnifiedSportEventsListState;
}

export const OutrightsCompetitionsList = observer(
    'OutrightsCompetitionsList',
    ({ competition, children }: OutrightsCompetitionsListPropsType) => {
        const common = useCommon();
        const starRouter = StarRouter.get(common);
        const { id, name, sport } = competition;
        const competitionName = competition.events.length === 1 ? competition.events[0]?.name ?? name : name;

        return (
            <React.Fragment key={id}>
                <SectionHeaderSeeMore
                    title={competitionName}
                    dataTest='outrights-competitions-list-header'
                    onClick={() => {
                        starRouter.redirectToCompetitionPage(id, sport, {
                            filter: 'outrights',
                        });
                    }}
                    isSeeMoreVisible={starRouter.currentView?.name !== 'competition'}
                />
                {children}
            </React.Fragment>
        );
    }
);
